import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { loginEduLegacyDefaultV0Schema } from './default';
import { loginEduLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch.
 *
 * Like the form and payment-form widgets, the variants diverge only on
 * `position` (plus the zero-only `isSynchronizeStyle` toggle): the default
 * branch carries the simple per-device grid, the zero branch requires the
 * extended-position grid.
 */
const loginEduLegacyEntityUnion = z.discriminatedUnion('type', [
    loginEduLegacyDefaultV0Schema,
    loginEduLegacyZeroV0Schema,
]);

export type LegacyLoginEduDefault = z.infer<typeof loginEduLegacyDefaultV0Schema>;
export type LegacyLoginEduZero = z.infer<typeof loginEduLegacyZeroV0Schema>;
export type LegacyLoginEduWidget = LegacyLoginEduDefault | LegacyLoginEduZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0
 * redesign yet). Single 'web' variant today.
 */
export const LegacyLoginEduWidgetEntitySchema = createLegacyEntitySchema([
    { name: 'web', schema: loginEduLegacyEntityUnion },
]);
